module.exports = __webpack_public_path__ + "static/media/AddressIcon.b28e86be.svg";